import React, { memo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useTheme,
} from '@mui/material';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import {
    AGENT_SOFTWARE_ID,
    JOB_NUMBER,
    MANTY_STATUS,
    ORG_CHART_HR_SOFTWARE_ID,
    RECURRENCE,
} from 'routes/HumanResourcesModule/business/definitions';

import { PAY_COMPONENT } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { PayComponent } from 'routes/HumanResourcesModule/PayState/helpers/constants';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import {
    AgentPayComponentHypothesis,
    DetailedAgentPayComponentHypothesis,
} from './helpers/types';
import AgentPayComponentHypothesisModalContent from './AgentPayComponentHypothesisModalContent';
import { getModalTitle } from './helpers/dataHelpers';
import { useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: () => void;
    hrSimulation: HrSimulation;
    hypothesis:
        | AgentPayComponentHypothesis
        | DetailedAgentPayComponentHypothesis;
    agentData: SimulationAgentData;
};

const AgentPayComponentResumeHypothesisModal = ({
    open,
    onClose,
    hrSimulation,
    hypothesis,
    agentData,
}: Props): React.ReactElement => {
    const theme = useTheme();
    const { t } = useTranslation();

    const filters = {
        [AGENT_SOFTWARE_ID]: agentData.agentSoftwareId,
        [JOB_NUMBER]: agentData.jobNumber,
        [MANTY_STATUS]: agentData.mantyStatus,
        [PAY_COMPONENT]: PayComponent.PONCTUAL_PRIMES,
        [ORG_CHART_HR_SOFTWARE_ID]: agentData.orgChartHrSoftwareId,
        [RECURRENCE]: hypothesis.recurrence,
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { backgroundColor: theme.palette.lightGrey },
            }}
        >
            <DialogTitle variant="h4" color="primary" sx={{ width: '95%' }}>
                {getModalTitle(agentData, hypothesis?.payComponent)}
            </DialogTitle>
            <DialogContent>
                <AgentPayComponentHypothesisModalContent
                    filters={filters}
                    hrSimulation={hrSimulation}
                    hypothesis={hypothesis}
                    isUpdateEnabled={false}
                    onValuesByDatesChange={() => {}}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default memo(AgentPayComponentResumeHypothesisModal);
